import React from "react";
import { DashboardSidebar, DashboardTopbar } from "./page.tsx";

type DashboardPlaceholderProps = {
  active: string;
  title: string;
  subtitle: string;
  preview?: boolean;
};

export default function DashboardPlaceholder({
  active,
  title,
  subtitle,
  preview = false,
}: DashboardPlaceholderProps) {
  return (
    <div className="min-h-screen bg-[#f4f7f1] text-[#0d2a1f]">
      <DashboardSidebar active={active} preview={preview} />

      <main className="min-h-screen xl:pl-[270px]">
        <DashboardTopbar />

        <div className="mx-auto max-w-[1120px] px-5 py-8 xl:px-7">
          <div className="mb-6">
            <h1 className="text-4xl font-black tracking-[-0.04em] text-[#0d2a1f]">
              {title}
            </h1>
            <p className="mt-2 text-base font-medium text-[#73827b]">
              {subtitle}
            </p>
          </div>

          <section className="rounded-[22px] border border-[#dfe8e1] bg-white p-8 text-center text-sm font-semibold text-[#73827b] shadow-[0_14px_34px_rgba(20,44,33,0.07)]">
            Esta pagina ja tem rota configurada e esta pronta para receber conteudo.
          </section>
        </div>
      </main>
    </div>
  );
}
